// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"22":"940f9c9b","663":"f14e900f","809":"292dca10","826":"19342fbc"}[chunkId] + ".css";
};